// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2-fWA","inputWrap":"styles_inputWrap__1Cr32","input":"styles_input__22Qrx"};